// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Py-z","tooltipWrapper":"Qy-z","icon":"Ry-z","tooltip":"Sy-z","content":"Ty-z"};